export default __webpack_public_path__ + "static/media/seo.6f274764.gif";